module.exports = require("live/components/forms/ui/label");